export * from './lib/fh-app-config.module';
export { EnvironmentModel } from './lib/helpers/objects/environment/environment-model';
import { InjectionToken } from '@angular/core';
export const APP_CONFIG = new InjectionToken('Application config');
